"use strict";
const moment = require('moment');
const c = require('../components/theme/colors');
const m = require('../models');
const format = require('./format');
exports.getTaskTime = (task) => {
    if (!task.activeSession) {
        return task.durationOfCompleteSessions;
    }
    return getSessionDuration(task.activeSession) + task.durationOfCompleteSessions;
};
exports.getGoalRemainder = (task) => {
    if (!task.activeSession) {
        return task.msLeftForGoal;
    }
    return task.msLeftForGoal - getSessionDuration(task.activeSession);
};
exports.getGoalStatusColor = (task) => {
    const goalRemainder = exports.getGoalRemainder(task);
    switch (true) {
        case task.goal.type === 1 /* AT_LEAST */ && goalRemainder <= 0:
            return c.green;
        case task.goal.type === 2 /* AT_MOST */ && goalRemainder <= 0:
            return c.red;
        default:
            return c.black;
    }
};
exports.getGoalMessage = (task) => {
    if (task.goal.type === 0 /* NONE */ || task.goal.duration === 0) {
        return;
    }
    const goalRemainder = exports.getGoalRemainder(task);
    if (task.goal.type === 1 /* AT_LEAST */) {
        if (goalRemainder > 0) {
            return format.timeRemaining(goalRemainder) + ' to go!';
        }
        else {
            return 'All done!';
        }
    }
    else {
        if (goalRemainder > 0) {
            return format.timeRemaining(goalRemainder) + ' left!';
        }
        else {
            return 'Time\'s up!';
        }
    }
};
exports.buildTaskHistory = (task, sessionsByDate = {}, today = moment()) => {
    // Build the current week.
    let date = moment(today).startOf('week');
    let history = {};
    for (let i = 0; i < 7; i++) {
        const dateString = date.format('YYYY-MM-DD');
        history[dateString] = exports.getGoalStatusForDate(task, date, sessionsByDate, today);
        date.add(1, 'day');
    }
    return history;
};
exports.getGoalStatusToday = (task) => {
    if (task.goal.type === 0 /* NONE */) {
        return 0 /* NO_GOAL */;
    }
    const now = moment();
    const dayOfWeek = now.day();
    if (!task.goal.repeats[dayOfWeek]) {
        return 0 /* NO_GOAL */;
    }
    const taskTime = exports.getTaskTime(task);
    const msLeftForGoal = exports.getMillisecondsLeftForGoal(task.goal, taskTime);
    switch (task.goal.type) {
        case 1 /* AT_LEAST */:
            return msLeftForGoal <= 0 ? 2 /* PASS */ : 1 /* PENDING */;
        case 2 /* AT_MOST */:
            return msLeftForGoal >= 0 ? 2 /* PASS */ : 3 /* FAIL */;
    }
};
exports.getGoalStatusForDate = (task, date, sessionsByDate = {}, now = moment()) => {
    if (task.goal.type === 0 /* NONE */) {
        return 0 /* NO_GOAL */;
    }
    if (date.isBefore(task.createdAt, 'day')) {
        return 0 /* NO_GOAL */;
    }
    if (date.isAfter(now, 'day')) {
        return 4 /* FUTURE */;
    }
    const dayOfWeek = date.day();
    if (!task.goal.repeats[dayOfWeek]) {
        return 0 /* NO_GOAL */;
    }
    const sessionsById = sessionsByDate[date.format('YYYY-MM-DD')] || {};
    const durationOfCompleteSessions = exports.sumSessionDurations(Object.keys(sessionsById).map(id => sessionsById[id]), true);
    const msLeftForGoal = exports.getMillisecondsLeftForGoal(task.goal, durationOfCompleteSessions);
    switch (task.goal.type) {
        case 1 /* AT_LEAST */:
            if (msLeftForGoal <= 0)
                return 2 /* PASS */;
            if (date.isSame(now, 'day'))
                return 1 /* PENDING */;
            return 3 /* FAIL */;
        case 2 /* AT_MOST */:
            if (msLeftForGoal >= 0)
                return 2 /* PASS */;
            return 3 /* FAIL */;
    }
};
exports.getMillisecondsLeftForGoal = (goal, durationOfSessions) => {
    if (goal.type === 0 /* NONE */) {
        return 0;
    }
    return goal.duration - durationOfSessions;
};
exports.sumSessionDurations = (sessions = [], completeSessionsOnly = false) => sessions.reduce((sum, session) => sum + getSessionDuration(session, completeSessionsOnly), 0);
const getSessionDuration = (session, completeSessionOnly = false) => {
    if (completeSessionOnly && !session.stoppedAt) {
        return 0;
    }
    return (session.stoppedAt || Date.now()) - session.startedAt;
};



/** WEBPACK FOOTER **
 ** ./src/utils/task.ts
 **/